import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { scrollToId } from '../lib/scroll';

const Navbar = () => {
  const links = [
    { label: 'About', id: 'about' },
    { label: 'Features', id: 'features' },
    { label: 'The App', id: 'showcase' },
    { label: 'Tools', id: 'tools' },
    { label: 'Contact', id: 'contact' }
  ];

  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 inset-x-0 z-50 bg-ink/70 backdrop-blur-xl border-b rule-dark"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => window.__lenis ? window.__lenis.scrollTo(0) : window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="flex items-center gap-2.5 group"
          aria-label="Back to top"
        >
          <img src="/symbionic-logo.png" alt="Symbionic" className="h-8 w-auto" />
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((link) => (
            <button
              key={link.id}
              data-testid={`nav-link-${link.id}`}
              onClick={() => scrollToId(link.id)}
              className="text-sm font-medium text-slate-400 hover:text-white transition-colors duration-300"
            >
              {link.label}
            </button>
          ))}
        </nav>

        <a
          data-testid="nav-cta"
          href="https://verifaeye.com.au"
          target="_blank"
          rel="noopener noreferrer"
          className="group inline-flex items-center gap-1.5 rounded-full bg-gradient-to-r from-cyan-400 to-emerald-400 px-5 py-2 text-sm font-semibold text-ink transition-transform duration-300 hover:scale-105"
        >
          Get VerifAEye
          <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </a>
      </div>
    </header>
  );
};

export default Navbar;
